import { Component, Input, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { DermService } from 'src/app/includes/derm/derm.service';

@Component({
  selector: 'app-derm-widget-list',
  templateUrl: './derm-widget-list.component.html',
  styleUrls: ['./derm-widget-list.component.css']
})
export class DermWidgetListComponent implements OnInit {
  @Input() provider;
  @Input() note;
  @Input() patient;
  @Input() readOnlyMode: any;
  @Input() dermState: string;

  dermsLoaderId = 'dermsLoaderId' + Math.random()

  derms: any[] = [];
  constructor(
    private _dermService: DermService,
    private loader: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    console.log(this.note);
    this.initDerm();
  }

  dermPayload(){
      const addNewDermPayloadD = {
        "isFollowUp": false,
        "followUpChange": "improved",
        "followUpProblem": "none",
        "followedRecommendations": "yes",
        "problem": "Acne",
        "otherProblem": "none",
        "provisionalDiagnosis": "none",
        "bodyParts": "none",
        "frequency": "always present",
        "hasBiopsy": false,
        "biopsyResult": "none",
        "hasMedication": "No",
        "howLong": "less than 1 week",
        "otherSymptoms": "none",
        "additionalInformation": "none",
        "questions": "none",
        "skinSymptoms": [
            "None of the above"
        ],
        "symptoms": [
            "None of the above"
        ],
        "validate": true,
        "hasMedications": "No",
        "hasMedicalProblems": "No",
        "hasAllergies": false,
        "hasSkinCondition": false,
        "medicalProblems": "",
        "allergies": "",
        "historyOfEczema": [],
        "historyOfMelanoma": [],
        "historyOfPsoriasis": [],
        "historyOfSkinCancer": [],
        "medications": [],


        "location_1": "head shot",
        "location_2": "default",
        "location_3": "skin",

        "patient_id": this.patient._id,
        "census_id": this.note.rounding_sheet_id,
        "facility_id": this.note.facility?._id,
        "created_by": this.provider._id,

        "image_file_1": "1642143476259.jpg",
        "image_file_2": "1642143476259.jpg",
        "image_file_3": "1642143476259.jpg",

        "image_patient_id": '6152e3c2c1d47c5f03780d8f'||this.patient._id

      }
      return addNewDermPayloadD;
  }

  async initDerm(){
    this.loader.startLoader(this.dermsLoaderId);
    // const resp:any = await this._dermService.addNewDerm(this.dermPayload()).toPromise();
    const { status, data } = await lastValueFrom(this._dermService.getAllDerms(this.patient._id, this.dermState)) as any;
    if(status == 200){
      this.derms = data;
    }
    this.loader.stopLoader(this.dermsLoaderId);
  }

  filterDerms(derms, dermState) {
    return derms.filter(derm => {
      return derm.state === dermState

    })
  }

  reloadDerms($event){
    if($event){
      this.initDerm();
    }
  }

}
